<template>
  <v-page-content>
    <div class="headerButtons">
      <!-- Кнопки редактирования контент-менеджера -->
      <b-alert
        variant="danger"
        :show="saveError && !isTestCreationMode && !isTestingMode"
      >
        Проверьте правильность заполнения полей
      </b-alert>
      <div v-if="(editMode || isTestCreationMode) && !isTestingMode">
        <b-button-toolbar class="float-right">
          <b-button-group>
            <b-button
              v-if="editMode"
              variant="primary"
              :pressed="true"
              class="mr-2"
            >
              <em class="fas fa-info" /> Статус: {{ status }}
            </b-button>
            <b-button
              v-if="canDelete && editMode && !isTestCreationMode"
              variant="outline-primary"
              class="mr-2"
              v-b-modal.my-modal.subsection-delete-confirmation-modal
            >
              <em class="fa fa-1x fa-times"></em> Удалить
            </b-button>
            <div
              v-else
              v-b-tooltip.hover
              title="Нельзя удалить последний подраздел"
            >
              <b-button
                v-if="canDelete && editMode && !isTestCreationMode"
                variant="outline-primary"
                class="mr-2"
                disabled
              >
                <em class="fa fa-1x fa-times"></em> Удалить
              </b-button>
            </div>
            <b-button
              v-if="editMode && !isTestCreationMode"
              variant="outline-primary"
              @click="onSaveClick()"
              :disabled="
                isContentSaved ||
                  isWaiting ||
                  Boolean(saveError) ||
                  updater === 0
              "
              class="mr-2"
            >
              <em class="far fa-1x fa-save"></em> Сохранить
            </b-button>
            <b-button
              v-if="editMode && !isTestCreationMode"
              variant="outline-primary"
              @click="onEditMode()"
              class="mr-2"
              :disabled="isWaiting"
            >
              <em :class="isEditMode ? 'far fa-edit' : 'fas fa-pen'"></em>
              {{ isEditMode ? ' Режим просмотра' : ' Редактировать' }}
            </b-button>
            <b-button
              v-if="isTestCreationMode && !isTestViewMode"
              variant="outline-primary"
              class="mr-2"
              @click="onTestSave"
            >
              <em class="far fa-1x fa-save"></em> Сохранить
            </b-button>
            <b-button
              v-if="isTestCreationMode"
              :variant="!isAlreadyInTest ? 'outline-primary' : 'primary'"
              class="mr-2"
              @click="toggleTask"
            >
              <div v-if="!isAlreadyInTest">
                <em class="fas fa-1x fa-plus mr-1"></em> Добавить в тест
              </div>
              <div v-else>
                <em class="fas fa-1x fa-minus mr-1"></em> Удалить из теста
              </div>
            </b-button>
            <b-button
              v-if="isTestCreationMode && !isTestViewMode"
              variant="outline-primary"
              @click="onViewMode"
              :disabled="numOfQuestions === 0"
              class="mr-2"
            >
              <em class="fas fa-1x fa-list"></em>
              Просмотр <b-badge variant="primary">{{ numOfQuestions }}</b-badge>
            </b-button>
            <b-button
              v-if="!isTestCreationMode"
              variant="outline-primary"
              @click="onClose"
            >
              <em class="fas fa1-x fa-times-circle" /> Закрыть
            </b-button>
            <b-button
              v-if="isTestCreationMode"
              variant="outline-primary"
              @click="onDecline"
              class="mr-2"
            >
              <em class="fas fa1-x fa-times-circle" />
              {{ isTestViewMode ? 'К выбору вопросов' : 'Закрыть' }}
            </b-button>
          </b-button-group>
        </b-button-toolbar>
      </div>
      <div
        v-if="!isTestCreationMode && (isTestViewMode || isTestReviewMode)"
        class="testCreationButtons"
      >
        <b-button variant="outline-dark" @click="onDecline">
          Назад
        </b-button>
      </div>
      <div v-if="isTestingMode">
        <b-button-toolbar class="float-right">
          <b-button-group>
            <b-button variant="primary" :pressed="true" class="mr-2">
              <em class="fas fa-info" /> Осталось времени:
              {{ testTimeLeft ? testTimeLeft : '-' }}
            </b-button>
            <b-button variant="outline-primary" class="mr-2">
              <em class="fa fa-1x fa-list"></em> Решено:
              {{ solvedTasks.length + ' / ' + numOfTasks }}
            </b-button>
            <b-button
              variant="outline-primary"
              class="mr-2"
              @click="finishTest"
            >
              <em class="fa fa-1x fa-check"></em> Завершить тест
            </b-button>
          </b-button-group>
        </b-button-toolbar>
      </div>
    </div>
    <div v-if="content">
      <h3>{{ content.title }}</h3>
      <h4>{{ isTestingMode || !courseTopic ? ' ' : courseTopic.title }}</h4>
      <h5>{{ isTestingMode || !courseSection ? ' ' : courseSection.title }}</h5>
    </div>
    <div v-if="isTestingMode">
      <br />
      <br />
    </div>
    <course-book-subsections-list
      v-if="content"
      :isNavigationEnabled="true"
      :isEditMode="isEditMode"
      :onAddSubSection="onShowAddSubsection"
    ></course-book-subsections-list>
    <div v-if="isQuestion && subsection && canSeeHidden" class="mb-2">
      <b-form-checkbox
        :checked="subsection.isSelfTest"
        :disabled="!isEditMode"
        @change="onSetSelfTest"
      >
        Вопрос самотестирования
      </b-form-checkbox>
    </div>
    <div>
      <div class="float-right mb-2" v-if="updater == 0">
        <b-button
          variant="outline-primary"
          @click="goBack"
          :disabled="isFirst || !isSubsectionLoaded || isEditMode"
          class="mr-2"
        >
          <em class="fas fa-angle-left"></em
        ></b-button>
        <b-button
          variant="outline-primary"
          @click="goNext"
          :disabled="isLast || !isSubsectionLoaded || isEditMode"
        >
          <em class="fas fa-angle-right"></em
        ></b-button>
      </div>
      <div
        v-else
        v-b-tooltip.hover
        title="Сохраните изменения"
        class="float-right mb-2"
      >
        <b-button variant="outline-primary" disabled class="mr-2">
          <em class="fas fa-angle-left"></em
        ></b-button>
        <b-button variant="outline-primary" disabled>
          <em class="fas fa-angle-right"></em
        ></b-button>
      </div>
      <div v-if="subsection">
        <component
          :is="subsectionComponent"
          :isEditMode="isEditMode"
          :onUpdated="onUpdated"
        />
      </div>
    </div>
    <b-modal
      centered
      size="lg"
      ref="addSubSection"
      id="addSubSection"
      title="Добавить подраздел"
      @ok="onAddSubSection"
      ok-title="Добавить"
      cancel-title="Отмена"
    >
      <div>Информационный</div>
      <b-form-radio-group
        v-model="subSectionToAdd"
        :options="options.info"
        name="radios-stacked"
        class="mb-3"
        stacked
      ></b-form-radio-group>
      <div>Вопрос</div>
      <b-form-radio-group
        v-model="subSectionToAdd"
        :options="options.test"
        name="radios-stacked"
        stacked
      ></b-form-radio-group>
    </b-modal>
    <b-modal
      centered
      size="lg"
      ref="testInvitations"
      id="testInvitations"
      hide-footer
      title="Приглашение на тест"
    >
      <test-invitations @closeEventModal="closeTestInvitationsModal">
      </test-invitations>
    </b-modal>
    <b-modal
      centered
      size="lg"
      ref="testSettings"
      id="testSettings"
      hide-footer
      title="Настройки теста"
    >
      <test-settings
        :numOfQuestions="
          courseSection && courseSection.subSections ? courseSection.subSections.length : 0
        "
        @closeEventModal="closeTestSettingsModal"
      >
      </test-settings>
    </b-modal>
    <leave-test-edit />
    <b-modal
      centered
      size="lg"
      ref="subsectionDeletConfirmationModal"
      id="subsection-delete-confirmation-modal"
      title="Удалить"
      @ok="onDeleteSubSection"
      ok-title="Удалить"
      cancel-title="Отмена"
    >
      <strong>Вы уверены, что хотите удалить подраздел?</strong>
    </b-modal>
    <finish-test-confirm />
  </v-page-content>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import moment from 'moment'

import RouteMixin from '@/components/helpers/mixins/route-mixin'
import TestMixin from '@/components/helpers/mixins/test-mixin'
import TestAPI from '@/api/test'
import DictsAPI from '@/api/dicts'

const TestInvitations = () => import('@/components/content/education/courses/modals/TestInvitations.vue')
const TestSettings = () => import('@/components/content/education/courses/modals/ModalTestSettings.vue')
const CourseBookSubsectionsList = () => import('@/components/content/education/courses/sub-sections/List.vue')
const TextInfoSubSection = () => import('@/components/content/education/courses/sub-sections/TextInfoSubSection.vue')
const FlashInfoSubSection = () => import('@/components/content/education/courses/sub-sections/FlashInfoSubSection.vue')
const ModelInfoSubSection = () => import('@/components/content/education/courses/sub-sections/ModelInfoSubSection.vue')
const VideoInfoSubSection = () => import('@/components/content/education/courses/sub-sections/VideoInfoSubSection.vue')
const TextTestSubSection = () => import('@/components/content/education/courses/sub-sections/TextTestSubSection.vue')
const FlashTestSubSection = () => import('@/components/content/education/courses/sub-sections/FlashTestSubSection.vue')
const ModelTestSubSection = () => import('@/components/content/education/courses/sub-sections/ModelTestSubSection.vue')
const FormulaTestSubSection = () => import('@/components/content/education/courses/sub-sections/FormulaTestSubSection.vue')
const LeaveTestEdit = () => import('@/components/content/education/courses/modals/LeaveTestEditModal.vue')
const FinishTestConfirm = () => import('@/components/content/education/courses/modals/FinishTestConfirm.vue')

export default {
  name: 'CourseBookSection',
  components: {
    FormulaTestSubSection,
    ModelTestSubSection,
    FlashTestSubSection,
    TextTestSubSection,
    VideoInfoSubSection,
    ModelInfoSubSection,
    FlashInfoSubSection,
    TextInfoSubSection,
    CourseBookSubsectionsList,
    TestInvitations,
    TestSettings,
    LeaveTestEdit,
    FinishTestConfirm
  },
  mixins: [RouteMixin, TestMixin],
  async mounted() {
    const updateAnswers = !(!this.content && !this.isTestCreationMode)
    if (!this.content) {
      await this.fetchCourseContent({
        id: this.$route.params.courseBookId
      })
    }

    if (!this.processCourseRights()) {
      return
    }

    if (this.getSubSectionHash(this.$route.params.subsectionId) === undefined) {
      this.$router.push('/page_not_exist')
      return
    }

    await this.fetchSubsection(this.$route.params.subsectionId)
    if (!this.hasRightsToView) {
      this.$router.push('/page_not_exist')
      return
    }
    this.$cookies.set(
      `ebook${this.$route.params.courseBookId}`,
      this.$route.params.subsectionId,
      '1m',
    )
    if (this.isTestingMode && this.test.timeLimit > 0) {
      const accessEndDate = moment(this.test.userTests[0].createdAt).add(this.test.timeLimit, 'm')
      const response = await DictsAPI.getCurrentTime()
      const currentTime = moment(response.data.time)
      if (accessEndDate.isAfter(currentTime)) {
        const diff = accessEndDate.valueOf() - currentTime.valueOf()
        this.localEndTime = moment(Date.now()).add(diff, 'ms')
        this.pollCurrentTime()
      }
    }

    if (updateAnswers) {
      try {
        const questions = this.$cookies
          .keys()
          .filter((k) => k.includes(`test_${this.test.id}`))
        const answeredQuestions = questions.filter((q) => {
          const answer = this.$cookies.get(q)
          return answer !== null
        })
        this.updateSolvedTasks(answeredQuestions)
      } catch (error) {
      }
    }
    this.updateUpdater(0)
    this.updateContentSavedStatus(true)
    window.onbeforeunload = undefined
    this.isLoading = false
  },
  props: {
    editMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: true,
      isEditMode: false,
      isSubsectionLoaded: true,
      isWaiting: false, // ?
      isSubsectionChanged: false,
      subSectionToAdd: 'text-info',
      options: {
        info: [
          { text: 'Текстовый формат (+изображения)', value: 'text-info' },
          { text: 'Видеозапись', value: 'video-info' },
          { text: 'Флэш', value: 'flash-info' },
          { text: '3D-модель', value: 'model-info' }
        ],
        test: [
          { text: 'Текстовый формат (+изображения)', value: 'text-test' },
          { text: 'Флэш', value: 'flash-test' },
          { text: '3D-модель', value: 'model-test' },
          { text: 'Формула', value: 'formula-test' }
        ]
      },
      // testing mode
      testTimeLeftPolling: null,
      testTimeLeft: '',
      testSolvedNum: '-',
      localEndTime: null,
      currentTimePolling: null,
      iter: 0
    }
  },
  methods: {
    ...mapActions({
      deleteCourse: 'education/deleteCourse',
      fetchCourseContent: 'education/fetchCourseContent',
      fetchSubsection: 'education/fetchSubsection',
      updateTestCreationMode: 'test/updateTestCreationMode',
      updateTestViewMode: 'test/updateTestViewMode',
      updateEditedTest: 'test/updateEditedTest',
      pushTaskToTest: 'education/pushTaskToTest',
      updateBackLink: 'test/updateBackLink',
      removeTaskFromTest: 'education/removeTaskFromTest',
      updateUpdater: 'contentManager/updateUpdater',
      updateCourse: 'education/updateCourse',
      updateSubsection: 'education/updateSubsection',
      deleteSubsection: 'education/deleteSubsection',
      pushToasts: 'toasts/pushToasts'
    }),
    ...mapMutations({
      updateContentSavedStatus: 'contentManager/updateContentSavedStatus',
      freezeUpdater: 'contentManager/freezeUpdater',
      addCourseSubsection: 'education/addCourseSubsection',
      setSubSectionIsSelfTest: 'education/setSubSectionIsSelfTest',
      setPositions: 'education/setCoursePositions',
      setTestingMode: 'test/setTestingMode',
      updateSolvedTasks: 'test/updateSolvedTasks',
      setTestReviewMode: 'educationStudentsManagement/setTestReviewMode'
    }),
    onEditMode() {
      this.isEditMode = !this.isEditMode
    },
    onUpdated() {
      this.updateUpdater(this.updater + 1)
    },
    onShowAddSubsection() {
      this.$bvModal.show('addSubSection')
    },
    onAddSubSection() {
      // eslint-disable-next-line arrow-body-style
      this.content.topics.some((topic, topicInternalId) => {
        return topic.sections.some((section, sectionInternalId) => {
          if (section.id === Number(this.$route.params.sectionId)) {
            this.addCourseSubsection({
              topicInternalId,
              sectionInternalId,
              type: this.subSectionToAdd
            })
            this.freezeUpdater(0)
            this.updateUpdater(this.updater + 1)
            this.$bvModal.hide('addSubSection')
            return true
          }
          return false
        })
      })
    },
    async onSaveClick() {
      this.isLoading = true
      await this.updateCourse(this.$route.params.courseBookId)
      await this.fetchCourseContent({ id: this.$route.params.courseBookId })
      await this.updateSubsection(this.$route.params.courseBookId)
      this.updateUpdater(0)
      this.isLoading = false
      window.onbeforeunload = undefined
      this.isEditMode = false
    },
    processCourseRights() {
      if (!this.canSeeHidden && this.status !== 'опубликовано') {
        this.$router.push('/page_not_exist')
        return false
      }
      if (!this.isMember && !this.canSeeHidden) {
        this.$router.push(
          `${this.$_getCourseRoutePrefix(this.$route.path)}${
            this.$route.params.courseBookId
          }`,
        )
        this.pushToasts({
          title: 'Уведомление',
          error: true,
          message: 'Вы не являетесь участником этого курса',
          time: 3
        })
        return false
      }
      if (
        this.courseTopic
        && this.courseTopic.title === 'Тестирование'
        && !this.isTestingMode
        && !this.isTestViewMode
        && !this.isTestReviewMode
      ) {
        this.$router.push(
          `${this.$_getCourseRoutePrefix(this.$route.path)}${
            this.$route.params.courseBookId
          }/test/${this.$route.params.sectionId}`,
        )
        return false
      }
      return true
    },
    onClose() {
      this.$router.push(
        `${this.$_getCourseRoutePrefix(this.$route.path)}${
          this.$route.params.courseBookId
        }`,
      )
    },
    async onDeleteSubSection() {
      this.isLoading = true
      const newPos = this.subsection.position
        - Number(
          this.subsection.position === this.courseSection.subSections.length - 1,
        )
      await this.deleteSubsection({
        topicInternalId: this.content.topics.findIndex(
          (p) => p.sections.filter(
            (s) => s.id === Number(this.$route.params.sectionId),
          ).length,
        ),
        sectionInternalId: this.courseTopic.sections.findIndex(
          (s) => s.id === Number(this.$route.params.sectionId),
        ),
        subSectionInternalId: this.courseSection.subSections.findIndex(
          (s) => s.id === Number(this.$route.params.subsectionId),
        )
      })
      await this.fetchCourseContent({ id: this.$route.params.courseBookId })
      const { section, subSection } = this.getSubSectionByPos(newPos)
      const link = this.getUrl(section, subSection)
      this.freezeUpdater(1)
      this.$router.push(link)
    },
    onSetSelfTest(isSelfTest) {
      this.onUpdated()
      this.setSubSectionIsSelfTest(isSelfTest)
    },
    exitTestCreationMode() {
      this.fetchCourseContent({ id: this.$route.params.courseBookId }).then(
        () => {
          this.updateTestCreationMode(false)
          this.$router.push(
            `${this.$_getCourseRoutePrefix(this.$route.path)}${
              this.$route.params.courseBookId
            }`,
          )
        },
      )
    },
    closeTestInvitationsModal() {
      this.$bvModal.hide('testInvitations')
    },
    closeTestSettingsModal() {
      this.$bvModal.hide('testSettings')
    },
    getSubSectionByPos(newPos) {
      if (newPos >= 0
        && newPos <= this.sortedSubsections[this
          .sortedSubsections.length - 1].position) {
        return {
          subSection: this.courseSection.subSections.find(
            (p) => p.position === newPos,
          ),
          section: this.courseSection,
          topic: this.courseTopic
        }
      }
      const currSecIndex = this.sortedSections
        .findIndex((s) => s.position === this.courseSection.position)
      const newSec = this.getSectionByPos(currSecIndex + (newPos >= 0 ? 1 : -1))
      const updPos = newPos < 0 ? newSec.subSections.length - 1 : 0
      return {
        section: newSec,
        subSection: newSec.subSections[updPos]
      }
    },
    getSectionByPos(secPos) {
      if (secPos >= 0 && secPos < this.sortedSections.length) {
        return this.sortedSections[secPos]
      }
      let currentTopicIndex = this.sortedTopics
        .findIndex((t) => t.position === this.courseTopic.position)
      let newTopic = null
      do {
        currentTopicIndex += secPos >= 0 ? 1 : -1
        // eslint-disable-next-line no-loop-func,prefer-destructuring
        newTopic = currentTopicIndex >= 0
          && currentTopicIndex < this.sortedTopics.length
          ? this.sortedTopics[currentTopicIndex]
          : null
      } while (newTopic && newTopic.sections.length === 0)
      if (newTopic) {
        const updIndex = secPos < 0 ? newTopic.sections.length - 1 : 0
        return newTopic.sections[updIndex]
      }
      return null
    },
    getUrl(section, subSection) {
      const courseId = this.$route.params.courseBookId
      return `${this.$_getCourseRoutePrefix(
        this.$route.path,
      )}${courseId}/section/${section.id}/subsection/${subSection.id}`
    },
    goBack() {
      const currentIndex = this.sortedSubsections.findIndex((s) => s.position === this.subsection.position)
      const { section, subSection } = this.getSubSectionByPos(
        currentIndex > 0 ? this.sortedSubsections[currentIndex - 1].position : -1,
      )
      const link = this.getUrl(section, subSection)
      this.$router.push(link)
    },
    goNext() {
      const currentIndex = this.sortedSubsections.findIndex((s) => s.position === this.subsection.position)
      const { section, subSection } = this.getSubSectionByPos(
        currentIndex < this.sortedSubsections.length - 1
          ? this.sortedSubsections[currentIndex + 1].position
          : this.sortedSubsections[this.sortedSubsections.length - 1].position + 1
      )
      const link = this.getUrl(section, subSection)
      this.$router.push(link)
    },
    toggleTask() {
      if (this.isAlreadyInTest) {
        if (Number(this.numOfQuestions) > 3) {
          this.removeTask()
        } else {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: 'В тесте должно быть минимум 3 вопроса!',
            time: 3
          })
        }
      } else {
        this.addTask()
      }
    },
    addTask() {
      this.pushTaskToTest({
        testId: this.test.id,
        task: this.subsection
      })
    },
    removeTask() {
      let goBackAfter = false
      if (this.courseSection.subSections.length > 1 && this.isTestViewMode) {
        if (this.subsection.position > 0) {
          this.goBack()
        } else {
          this.goNext()
        }
      } else if (this.isTestViewMode) {
        goBackAfter = true
      }
      this.removeTaskFromTest({
        testId: this.test.id,
        taskId: this.subsection.id
      })
      if (goBackAfter) {
        this.onDecline()
      }
    },
    onTestSave() {
      TestAPI.updateTestQuestions(
        this.$route.params.courseBookId,
        this.editedTestId,
        this.courseContent.topics[this.courseContent.topics.length - 1].sections
          .find((s) => s.id === Number(this.editedTestId))
          .subSections.map((ss) => ss.id),
      ).then(() => {
        this.updateTestCreationMode(false)
        TestAPI.restTestsettings(
          this.$route.params.courseBookId,
          this.editedTestId,
        ).then(() => {
          this.$router.push(
            `${this.$_getCourseRoutePrefix(this.$route.path)}${
              this.$route.params.courseBookId
            }/test/${this.editedTestId}`,
          )
          this.pushToasts({
            title: 'Уведомление',
            message: 'Настройки теста были сброшены',
            time: 3
          })
        })
      })
    },
    onViewMode() {
      this.setPositions()
      this.updateTestViewMode(true)
      this.updateBackLink(this.$route.path)
      this.$router.push(
        `${this.$_getCourseRoutePrefix(this.$route.path)}${
          this.$route.params.courseBookId
        }/section/${this.editedTestId}/subsection/${
          this.courseContent.topics[
            this.courseContent.topics.length - 1
          ].sections.find((s) => s.id === Number(this.editedTestId))
            .subSections[0].id
        }`,
      )
    },
    onDecline() {
      if (this.isTestCreationMode && !this.isTestViewMode) {
        this.$bvModal.show('leaveTestEdit')
      } else if (this.isTestViewMode || this.isTestReviewMode) {
        this.updateTestViewMode(false)
        this.$router.push(this.backLink)
      }
    },
    timeLeft() {
      if (this.isTestingMode) {
        if (this.test.timeLimit > 0) {
          if (this.localEndTime.valueOf() - Date.now() < 1000) {
            clearInterval(this.currentTimePolling)
            const questions = this.$cookies
              .keys()
              .filter((k) => k.includes(`test_${this.test.id}`))
            const answers = []
            questions.forEach((q) => {
              answers.push({
                id: this.test.subSections.find(
                  (ss) => ss.id === Number(q.split('_')[2]),
                ).task.id,
                answer:
                  q.split('_')[3] === 'flash' || q.split('_')[3] === 'formula'
                    ? this.$cookies.get(q)
                    : JSON.parse(this.$cookies.get(q))
              })
            })
            TestAPI.sendTestAnswers(
              this.$route.params.courseBookId,
              this.$route.params.sectionId,
              answers,
            ).then((response) => {
              clearInterval(this.currentTimePolling)
              if (response.status === 200) {
                const cAnswers = this.$cookies
                  .keys()
                  .filter((k) => k.includes(`test_${this.test.id}`))
                cAnswers.forEach((a) => {
                  this.$cookies.remove(a)
                })
                this.$router.push(
                  `/education/${this.$route.params.courseBookId}/test/${
                    this.test.id
                  }`,
                )
              }
            })
          }
          return this.$_getTimeDifference(this.localEndTime.valueOf(), Date.now())
        }

        return 'не ограничено'
      }

      return 'не ограничено'
    },
    pollCurrentTime() {
      this.currentTimePolling = setInterval(() => {
        this.testTimeLeft = this.timeLeft()
        this.iter += 1
        if (this.iter === 4) {
          this.iter = 0
          clearInterval(this.currentTimePolling)
          this.pollCurrentTime()
        }
      }, 300)
    },
    finishTest() {
      this.$bvModal.show('confirmFinishTest')
    },
    onBeforeRouteLeave(to, from, next) {
      clearInterval(this.currentTimePolling)
      this.testTimeLeft = ''
      if (this.isTestingMode) {
        this.setTestingMode(false)
      }
      next()
    },
    async onBeforeRouteUpdate(to, from, next) {
      this.isSubsectionLoaded = false
      try {
        await this.fetchSubsection(to.params.subsectionId)
      } finally {
        this.isSubsectionLoaded = true
      }
      this.$cookies.set(
        `ebook${to.params.courseBookId}`,
        to.params.subsectionId,
        '1m',
      )
      this.testTimeLeft = this.timeLeft()
      if (this.isTestingMode) {
        const questions = this.$cookies
          .keys()
          .filter((k) => k.includes(`test_${this.test.id}`))
        const answeredQuestions = questions.filter((q) => {
          const answer = this.$cookies.get(q)
          return answer !== null
        })
        this.updateSolvedTasks(answeredQuestions)
      }
      next()
    }
  },
  watch: {
    updater(newUpdater) {
      if (newUpdater > 0) {
        this.updateContentSavedStatus(false)
        window.onbeforeunload = () => 'Имеются несохранённые изменения. Вы точно хотите закрыть страницу?'
      } else {
        this.updateContentSavedStatus(true)
        window.onbeforeunload = undefined
      }
    }
  },
  computed: {
    ...mapGetters({
      backLink: 'test/getBackLink',
      courseContent: 'education/getCourseContent',
      editedTestId: 'test/getEditedTestId',
      getSubSectionHash: 'education/getSubSectionHash',
      hasRole: 'currentUser/hasRole',
      isContentSaved: 'contentManager/isContentSaved',
      isMember: 'education/getCourseMember',
      isTestCreationMode: 'test/isTestCreationMode',
      isTestReviewMode: 'educationStudentsManagement/getTestReviewMode',
      isTestViewMode: 'test/isTestViewMode',
      isTestingMode: 'test/isTestingMode',
      newTestTasks: 'education/getNewTestTasks',
      saveError: 'contentManager/getErrorWithChangingTextTestSubsection',
      solvedTasks: 'test/getSolvedTasks',
      subsection: 'education/getSubsection',
      test: 'test/getTest',
      testContent: 'education/getTestContent',
      updater: 'contentManager/getUpdater'
    }),
    sortedTopics() {
      return this.content && this.content.topics
        ? this.content.topics.sort((s1, s2) => s1.position - s2.position) : []
    },
    sortedSections() {
      return this.courseTopic && this.courseTopic.sections
        ? this.courseTopic.sections.sort((s1, s2) => s1.position - s2.position) : []
    },
    sortedSubsections() {
      return this.courseSection && this.courseSection.subSections
        ? this.courseSection.subSections.sort((s1, s2) => s1.position - s2.position) : []
    },
    content() {
      return this.isTestCreationMode && !this.isTestViewMode
        ? this.testContent
        : this.courseContent
    },
    subsectionComponent() {
      switch (this.subsection.type) {
        case 'text-info':
          return 'text-info-sub-section'
        case 'flash-info':
          return 'flash-info-sub-section'
        case 'model-info':
          return 'model-info-sub-section'
        case 'video-info':
          return 'video-info-sub-section'
        case 'text-test':
          return 'text-test-sub-section'
        case 'flash-test':
          return 'flash-test-sub-section'
        case 'model-test':
          return 'model-test-sub-section'
        case 'formula-test':
          return 'formula-test-sub-section'
        default:
          return ''
      }
    },
    canDelete() {
      if (this.courseSection && this.courseSection.subSections) {
        return this.courseSection.subSections.length > 1
      }
      return false
    },
    isQuestion() {
      if (this.subsection && this.subsection.type) {
        return this.subsection.type.includes('test')
      }
      return false
    },
    canSeeHidden() {
      return (
        this.hasRole('content-manager')
        || this.hasRole('verification-specialist')
        || this.hasRole('classroom-teacher')
      )
    },
    hasRightsToView() {
      return (
        this.canSeeHidden || this.subsection.isSelfTest || this.isTestingMode
      )
    },

    isFirst() {
      if (
        this.content
        && this.subsection
        && (this.isTestViewMode || this.isTestReviewMode || this.isTestingMode)
      ) {
        return !this.subsection.position
      }
      if (this.content && this.subsection) {
        return (
          !this.courseTopic.position
          && !this.courseSection.position
          && !this.subsection.position
        )
      }
      return true
    },
    isLast() {
      if (
        this.content
        && this.subsection
        && (this.isTestViewMode || this.isTestingMode || this.isTestReviewMode)
      ) {
        return (
          this.subsection.position === this.courseSection.subSections.length - 1
        )
      }
      if (this.content && this.subsection && this.courseSection.subSections) {
        return (
          this.subsection.position
            === this.courseSection.subSections.length - 1
          && this.courseSection.position
            === this.courseTopic.sections.length - 1
          && this.courseTopic.position === this.content.topics.length - 2
        )
      }
      return true
    },
    courseTopic() {
      if (this.content && this.content.topics) {
        if (this.isTestingMode || this.isTestViewMode || this.isTestReviewMode) {
          return this.content.topics[this.content.topics.length - 1]
        }
        return this.content.topics.find(
          (p) => p.sections.find(
            (s) => s.id === Number(this.$route.params.sectionId)
          )
        )
      }
      return { title: '', position: 0 }
    },
    courseSection() {
      if (this.content) {
        return this.courseTopic.sections.find(
          (s) => s.id === Number(this.$route.params.sectionId)
        )
      }

      return { title: '' }
    },
    isAlreadyInTest() {
      if (
        this.courseContent.topics[
          this.courseContent.topics.length - 1
        ].sections.find((s) => s.id === Number(this.editedTestId))
          .subSections.length > 0
        && this.subsection
      ) {
        return this.courseContent.topics[
          this.courseContent.topics.length - 1
        ].sections.find((s) => s.id === Number(this.editedTestId))
          .subSections
          ? this.courseContent.topics[
            this.courseContent.topics.length - 1
          ].sections
            .find((s) => s.id === Number(this.editedTestId))
            .subSections.filter((ss) => ss.id === this.subsection.id).length
              > 0
          : false
      }

      return false
    },
    numOfQuestions() {
      if (this.isTestCreationMode) {
        return this.courseContent.topics[
          this.courseContent.topics.length - 1
        ].sections.filter((s) => s.id === Number(this.editedTestId))[0]
          .subSections.length
      }

      return 0
    },
    status() {
      if (this.content && this.content.contentObject) {
        return this.content.contentObject.status
      }
      return ''
    },
    isRemoved() {
      return this.status === 'удалено'
    },
    numOfTasks() {
      if (this.isTestingMode && this.test) {
        return this.test.subSections.length
      }

      return 0
    }
  }
}
</script>

<style lang="scss" scoped>
.headerButtons {
  margin-bottom: 10px;
}

.testInfo {
  margin: 0 auto;
  text-align: center;
  display: flex;
  justify-content: center;

  &__card {
    width: 50%;
  }

  &__duration {
    margin: 25px;
  }
}
</style>
